import React, { useState } from "react";
import { TouchableOpacity, View, ActivityIndicator, Text } from "react-native";

import { useScreenDimensions, useDevice } from "../_layout";
import { useTranslation } from "react-i18next";
import CustomActivityIndicator from "./CustomActivityIndicator";

import Colors from "../../Resources/Color";

const SaveCancelButtons = ({ text, isCancel, disabled, action }) => {
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <TouchableOpacity
      onPress={action}
      disabled={disabled}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <View
        style={{
          backgroundColor: isCancel ? Colors.bubbleColor : Colors.whiteColor,
          borderRadius: 14,
          borderWidth: 1,
          justifyContent: "center",
          borderColor: isCancel ? Colors.bubbleColor : "red",
          width: 80,
          height: 35,
          justifyContent: "center",
          alignItems: "center",
          opacity: isHovered ? 0.7 : disabled ? 1 : 0.5,
          marginHorizontal: !isCancel && 10,
        }}
      >
        {isLoading && isCancel ? (
          <CustomActivityIndicator large={false} white={true} />
        ) : (
          <Text
            style={{
              textAlignVertical: "center",
              textAlign: "center",
              color: isCancel ? Colors.whiteColor : "red",
            }}
          >
            {t(text)}
          </Text>
        )}
      </View>
    </TouchableOpacity>
  );
};

export default SaveCancelButtons;
